import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  TextField,
  Radio,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import { setDashboardAbsentReason } from "../../../store/dashboardReducer";
import Error from "../../Error/Error";
import moment from "moment";
import MyTable from "../../Schedule/MyTable";
import { getGridStringOperators } from "@mui/x-data-grid";
import { toast } from 'react-toastify';

export default function PTOTotals() {
  // const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const dispatch = useDispatch();
  const AbsentReason = useSelector(
    (state) => state.dashboardReducer.AbsentReason
  );
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      type: "PERIOD_START",
    },
  });
  let columns = [
    {
      field: "Emp_Code",
      headerName: "Emp Code",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "fullName",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) =>
        params.row?.employee_assignment?.EA_Rank + " " + params.row.fullName,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "EA_Status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) =>
        params.row?.employee_assignment?.EA_Division +
        " " +
        params.row?.employee_assignment?.EA_Status,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  const onSubmit = (body) => {
    ApiService.post("/createEmployeeTotal", body)
      .then(({ data }) => {
        console.log("data", data);
        setModalData(data);
        reset();
        setOpen(true);
        toast.success("Success")
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };
  useEffect(() => {
    ApiService.get("/absentCodes?condition=all", {}, "absentCodes")
      .then(({ data }) => {
        dispatch(setDashboardAbsentReason(data.data));
      })
      .catch(() => {
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
  }, []);
  let closeModal = () => {
    reset();
    setOpen(false);
  };
  return (
    <>
      <Typography fontWeight="700" fontSize="16px">
        {" "}
        PTO Totals
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-12 col-md-6 col-lg-3">
          <FormControl
            required={true}
            fullWidth
          >
            <label style={{ fontSize: '14px' }}>Type</label>
            <Select
              className="mt-2"
              sx={{
                height: '48px',
                '& .MuiOutlinedInput-root': {
                  height: '48px',
                  '& .MuiSelect-select': {
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                },
              }}
              MenuProps={{ disableScrollLock: true }}
              {...register("type", { required: "Type  is required." })}
              defaultValue="PERIOD_START"
            >
              <MenuItem value="PERIOD_START">PERIOD START</MenuItem>
              <MenuItem value="ACCRUED">ACCRUED</MenuItem>
            </Select>
            {errors.type && <Error>{errors.type?.message}</Error>}
          </FormControl>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <label style={{ fontSize: '14px' }}>Date</label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              className="mt-1"
              {...register("date", { required: "Date is required" })}
              format="yyyy/MM/dd"
              onChange={(e) => setValue("date", moment(e).format("YYYY-MM-DD"))}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: '48px'
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#c4c4c4 !important",
                },
                "& .Mui-focused": { color: "#c4c4c4 !important" },
              }}
            />
          </LocalizationProvider>
          {errors.date && <Error>{errors.date?.message}</Error>}
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <FormControl
            required={true}
            fullWidth
          >
            <label style={{ fontSize: '14px' }}>Sub type</label>
            <Select
              className="mt-2"
              sx={{
                height: '48px'
              }}
              MenuProps={{ disableScrollLock: true }}
              {...register("subtype", { required: "SubType  is required." })}
            >
              {Object.entries(AbsentReason)?.map((option) => (
                <MenuItem value={option[0]} key={option[0]}>
                  {option[1]}{" "}
                </MenuItem>
              ))}
            </Select>
            {errors.subtype && <Error>{errors.subtype?.message}</Error>}
          </FormControl>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <FormControl
            required={true}
            fullWidth
          >
            <label style={{ fontSize: '14px' }}>Total</label>
            <TextField
              className="mt-2"
              sx={{
                "& .MuiInputBase-input": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
              InputProps={{
                sx: {
                  height: '48px',
                }
              }}
              type="number"
              {...register("total", { required: "Value  is required." })}
            />
            {errors.total && <Error>{errors.total?.message}</Error>}
          </FormControl>
        </div>
        <div className="col-12 mt-3">
          <ButtonTheme color="primary" type="submit">
            Add PTO Totals
          </ButtonTheme>
        </div>
      </form>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "90vw" } }}
        maxWidth="lg"
        open={open}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Employee</DialogTitle>
        <DialogContent>
          <MyTable
            rows={modalData}
            columns={columns}
            useTopFilter={false}
            checkboxSelection={false}
            hideFooter={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
